<template>
  <el-dialog
    :title="'配置商品模板'"
    :visible.sync="innerVisible"
    width="52%"
    @close="onClose"
  >
    <div class="dialog-header">
      <span class="header-label">{{ goodsTypeLabel }}</span>
      <el-button type="primary" size="small" @click="onSubmit">保存</el-button>
    </div>
    <el-divider></el-divider>

    <div class="card-list" v-loading="table.loading">
      <div
        v-for="item in table.list"
        :key="item.id"
        class="card-list-item"
      >
        <el-card
          shadow="hover"
          class="template-card"
          :class="{ 'is-active': selectedTplId === item.id }"
          @click.native="onChooseCard(item)"
        >
          <div class="card-head">
            <span class="card-title">{{ item.templateName }}</span>
          </div>
          <div class="card-tags">
            <el-tag size="small" type="warning">{{ goodsTypeLabel }}</el-tag>
          </div>
        </el-card>
      </div>
    </div>

    <div v-if="!table.loading && table.list.length === 0" class="empty-tip">
      暂无模板数据
    </div>

    <div class="pagination-wrapper">
      <el-pagination
        background
        layout="prev, pager, next"
        :current-page.sync="table.currentPage"
        :page-size="table.pageSize"
        :total="table.total"
      />
    </div>
  </el-dialog>
</template>

<script>
import { getTemplatePage } from "../../goods-price-template/api.js";
import { bindStoreGoodsPriceTplAPI, batchBindStoreGoodsPriceTplAPI } from "../api";

export default {
  name: "GoodsPriceTplSelectDialog",
  props: {
    visible: { type: Boolean, default: false },
    storeIdList: { type: Array, default: () => [] },
    storeId: { type: [Number, String], default: null },
    goodsType: { type: Number, default: 1 },
    currentTplId: { type: [Number, String], default: null },
  },
  data() {
    return {
      innerVisible: false,
      selectedTplId: null,
      table: {
        currentPage: 1,
        pageSize: 8,
        total: 0,
        loading: false,
        list: [],
      },
    };
  },
  computed: {
    goodsTypeLabel() {
      return this.goodsType === 1 ? "3C商品模板" : "电车商品模板";
    },
  },
  watch: {
    visible: {
      immediate: true,
      handler(val) {
        this.innerVisible = val;
        if (val) {
          this.selectedTplId = this.currentTplId || null;
          this.table.currentPage = 1;
          this.getList();
        }
      },
    },
    "table.currentPage"() {
      if (!this.innerVisible) return;
      this.getList();
    },
  },
  methods: {
    // 获取商品价格模板分页
    async getList() {
      this.table.loading = true;
      try {
        const res = await getTemplatePage({
          goodsType: this.goodsType,
          page: this.table.currentPage,
          pageSize: this.table.pageSize,
        });
        this.table.list = (res.list || []).map((item) => ({
          id: item.id,
          templateName: item.tplName,
          isDefault: item.isDefault,
        }));
        this.table.total = res.total || 0;
      } finally {
        this.table.loading = false;
      }
    },
    onChooseCard(item) {
      this.selectedTplId = item.id;
    },
    async onSubmit() {
      if (!this.selectedTplId) {
        this.$message.error("请选择商品模板");
        return;
      }
      const targetStoreIdList = this.storeIdList.length
        ? this.storeIdList
        : this.storeId
          ? [this.storeId]
          : [];
      if (!targetStoreIdList.length) {
        this.$message.error("请选择门店");
        return;
      }
      if (targetStoreIdList.length > 1) {
        // 批量
        await batchBindStoreGoodsPriceTplAPI({
          storeIdList: targetStoreIdList,
          goodsPriceTplId: this.selectedTplId,
        });
      } else {
        // 单个
        await bindStoreGoodsPriceTplAPI({
          id: targetStoreIdList[0],
          goodsPriceTplId: this.selectedTplId,
        });
      }
      this.$message.success("保存成功");
      this.$emit("saved");
      this.onClose();
    },
    onClose() {
      this.$emit("update:visible", false);
    },
  },
};
</script>

<style lang="scss" scoped>
.dialog-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 4px;

  .header-label {
    font-size: 15px;
    font-weight: 600;
    color: #303133;
  }
}

.card-list {
  display: flex;
  flex-wrap: wrap;
  margin: 0 -8px;
}

.card-list-item {
  width: 25%;
  padding: 0 8px;
  margin-bottom: 16px;
  box-sizing: border-box;
}

.template-card {
  cursor: pointer;
  border: 2px solid #ebeef5;
  border-radius: 8px;
  transition: all 0.2s;

  &:hover {
    border-color: #b3d8ff;
  }

  &.is-active {
    border-color: #409eff;
    box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.2);
  }

  /deep/ .el-card__body {
    padding: 16px;
  }

  .card-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 8px;
    padding: 10px 12px;
    border: 1px solid #ebeef5;
    border-radius: 6px;
    background: #fafafa;

    .card-title {
      font-size: 15px;
      font-weight: 600;
      color: #303133;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }

  .card-tags {
    display: flex;
    align-items: center;
    gap: 8px;
  }
}

.empty-tip {
  text-align: center;
  color: #909399;
  padding: 40px 0;
  font-size: 14px;
}

.pagination-wrapper {
  display: flex;
  justify-content: flex-end;
  margin-top: 10px;
}
</style>
